module.exports = __webpack_public_path__ + "img/8.d4e7f2ea.jpg";